// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-range-input-picker {
  outline: none;
  position: relative;
}
.dl-range-input-picker__range-info-items-list {
  position: absolute;
  top: 44px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.dl-range-input-picker__range-info-item-container {
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}
.dl-range-input-picker__range-info-item {
  cursor: pointer;
  color: var(--g-color-text-secondary);
  font-size: var(--dl-range-input-picker-font-size);
  line-height: var(--dl-range-input-picker-line-height);
}
.dl-range-input-picker .rc-slider {
  position: relative;
  bottom: 6px;
  z-index: 3;
  height: 14px;
  padding: 5px 0;
  width: calc(100% - var(--dl-range-input-picker-border-radius));
  left: calc(var(--dl-range-input-picker-border-radius) / 2);
  border-radius: 6px;
  touch-action: none;
  box-sizing: border-box;
}
.dl-range-input-picker .rc-slider-rail {
  position: absolute;
  width: 100%;
  height: 4px;
  border-radius: 6px;
}
.dl-range-input-picker .rc-slider-track {
  position: absolute;
  left: 0;
  top: 2px;
  height: 4px;
  border-radius: 6px;
  background-color: var(--g-color-base-brand);
}
.dl-range-input-picker .rc-slider-handle {
  position: absolute;
  top: -2px;
  width: 12px;
  height: 12px;
  cursor: pointer;
  border-radius: 50%;
  background-color: var(--g-color-base-brand);
  touch-action: pan-x;
}
.dl-range-input-picker .rc-slider-handle:active {
  box-shadow: 0 0 5px var(--g-color-base-brand);
  cursor: grabbing;
}
.dl-range-input-picker .rc-slider-handle:focus {
  box-shadow: 0 0 0 5px var(--g-color-base-selection);
  outline: none;
}
.dl-range-input-picker .rc-slider-disabled .rc-slider-handle {
  box-shadow: none;
  background-color: var(--g-color-base-float);
  cursor: not-allowed;
}
.dl-range-input-picker .rc-slider-disabled .rc-slider-track {
  background-color: var(--g-color-sfx-veil);
}
.dl-range-input-picker .rc-slider-step {
  position: absolute;
  transform: translateY(-50%);
  width: 100%;
  height: 4px;
  background: transparent;
}
.dl-range-input-picker .rc-slider-mark {
  position: absolute;
  top: 13px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.dl-range-input-picker .rc-slider-mark-text {
  transform: translateX(0) !important;
  cursor: pointer;
  color: var(--g-color-text-secondary);
  font-size: var(--dl-range-input-picker-font-size);
  line-height: var(--dl-range-input-picker-line-height);
}
.dl-range-input-picker_size_s {
  --dl-range-input-picker-border-radius: var(--g-border-radius-s);
  --dl-range-input-picker-font-size: var(--g-text-body-short-font-size);
  --dl-range-input-picker-line-height: var(--g-text-body-short-line-height);
}
.dl-range-input-picker_size_s .dl-range-input-picker__range-info-items-list {
  top: 31px;
}
.dl-range-input-picker_size_s .rc-slider-handle {
  top: 0;
  width: 9px;
  height: 9px;
}
.dl-range-input-picker_size_s .rc-slider-track {
  top: 4px;
  height: 2px;
}
.dl-range-input-picker_size_s .rc-slider-step {
  height: 2px;
}
.dl-range-input-picker_size_m {
  --dl-range-input-picker-border-radius: var(--g-border-radius-m);
  --dl-range-input-picker-font-size: var(--g-text-body-short-font-size);
  --dl-range-input-picker-line-height: var(--g-text-body-short-line-height);
}
.dl-range-input-picker_size_m .dl-range-input-picker__range-info-items-list {
  top: 35px;
}
.dl-range-input-picker_size_m .rc-slider-handle {
  top: -1px;
  width: 11px;
  height: 11px;
}
.dl-range-input-picker_size_m .rc-slider-track {
  top: 3px;
  height: 3px;
}
.dl-range-input-picker_size_m .rc-slider-step {
  height: 3px;
}
.dl-range-input-picker_size_l {
  --dl-range-input-picker-border-radius: var(--g-border-radius-l);
  --dl-range-input-picker-font-size: var(--g-text-body-short-font-size);
  --dl-range-input-picker-line-height: var(--g-text-body-short-line-height);
}
.dl-range-input-picker_size_l .dl-range-input-picker__range-info-items-list {
  top: 43px;
}
.dl-range-input-picker_size_xl {
  --dl-range-input-picker-border-radius: var(--g-border-radius-xl);
  --dl-range-input-picker-font-size: var(--g-text-body-2-font-size);
  --dl-range-input-picker-line-height: var(--g-text-body-2-line-height);
}
.dl-range-input-picker_size_xl .dl-range-input-picker__range-info-items-list {
  top: 51px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/RangeInputPicker/RangeInputPicker.scss"],"names":[],"mappings":"AAIA;EAEI,aAAA;EACA,kBAAA;AAJJ;AAMI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AAJR;AAOI;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AALR;AAQI;EACI,eAAA;EACA,oCAAA;EACA,iDAAA;EACA,qDAAA;AANR;AASI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,8DAAA;EACA,0DAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAPR;AASQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAPZ;AAUQ;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,2CAzDA;AAiDZ;AAWQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,2CAnEA;EAoEA,mBAAA;AATZ;AAWY;EACI,6CAAA;EACA,gBAAA;AAThB;AAYY;EACI,mDAAA;EACA,aAAA;AAVhB;AAcQ;EACI,gBAAA;EACA,2CAAA;EACA,mBAAA;AAZZ;AAeQ;EACI,yCAtFS;AAyErB;AAgBQ;EACI,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;AAdZ;AAiBQ;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AAfZ;AAiBY;EAEI,mCAAA;EACA,eAAA;EACA,oCAAA;EACA,iDAAA;EACA,qDAAA;AAhBhB;AAqBI;EACI,+DAAA;EACA,qEAAA;EACA,yEAAA;AAnBR;AAqBQ;EACI,SAAA;AAnBZ;AAuBY;EACI,MAAA;EACA,UAAA;EACA,WAAA;AArBhB;AAwBY;EACI,QAAA;EACA,WAAA;AAtBhB;AAyBY;EACI,WAAA;AAvBhB;AA4BI;EACI,+DAAA;EACA,qEAAA;EACA,yEAAA;AA1BR;AA4BQ;EACI,SAAA;AA1BZ;AA8BY;EACI,SAAA;EACA,WAAA;EACA,YAAA;AA5BhB;AA+BY;EACI,QAAA;EACA,WAAA;AA7BhB;AAgCY;EACI,WAAA;AA9BhB;AAmCI;EACI,+DAAA;EACA,qEAAA;EACA,yEAAA;AAjCR;AAmCQ;EACI,SAAA;AAjCZ;AAqCI;EACI,gEAAA;EACA,iEAAA;EACA,qEAAA;AAnCR;AAqCQ;EACI,SAAA;AAnCZ","sourcesContent":[".dl-range-input-picker {\n  outline: none;\n  position: relative;\n}\n.dl-range-input-picker__range-info-items-list {\n  position: absolute;\n  top: 44px;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.dl-range-input-picker__range-info-item-container {\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n}\n.dl-range-input-picker__range-info-item {\n  cursor: pointer;\n  color: var(--g-color-text-secondary);\n  font-size: var(--dl-range-input-picker-font-size);\n  line-height: var(--dl-range-input-picker-line-height);\n}\n.dl-range-input-picker .rc-slider {\n  position: relative;\n  bottom: 6px;\n  z-index: 3;\n  height: 14px;\n  padding: 5px 0;\n  width: calc(100% - var(--dl-range-input-picker-border-radius));\n  left: calc(var(--dl-range-input-picker-border-radius) / 2);\n  border-radius: 6px;\n  touch-action: none;\n  box-sizing: border-box;\n}\n.dl-range-input-picker .rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  border-radius: 6px;\n}\n.dl-range-input-picker .rc-slider-track {\n  position: absolute;\n  left: 0;\n  top: 2px;\n  height: 4px;\n  border-radius: 6px;\n  background-color: var(--g-color-base-brand);\n}\n.dl-range-input-picker .rc-slider-handle {\n  position: absolute;\n  top: -2px;\n  width: 12px;\n  height: 12px;\n  cursor: pointer;\n  border-radius: 50%;\n  background-color: var(--g-color-base-brand);\n  touch-action: pan-x;\n}\n.dl-range-input-picker .rc-slider-handle:active {\n  box-shadow: 0 0 5px var(--g-color-base-brand);\n  cursor: grabbing;\n}\n.dl-range-input-picker .rc-slider-handle:focus {\n  box-shadow: 0 0 0 5px var(--g-color-base-selection);\n  outline: none;\n}\n.dl-range-input-picker .rc-slider-disabled .rc-slider-handle {\n  box-shadow: none;\n  background-color: var(--g-color-base-float);\n  cursor: not-allowed;\n}\n.dl-range-input-picker .rc-slider-disabled .rc-slider-track {\n  background-color: var(--g-color-sfx-veil);\n}\n.dl-range-input-picker .rc-slider-step {\n  position: absolute;\n  transform: translateY(-50%);\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n.dl-range-input-picker .rc-slider-mark {\n  position: absolute;\n  top: 13px;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.dl-range-input-picker .rc-slider-mark-text {\n  transform: translateX(0) !important;\n  cursor: pointer;\n  color: var(--g-color-text-secondary);\n  font-size: var(--dl-range-input-picker-font-size);\n  line-height: var(--dl-range-input-picker-line-height);\n}\n.dl-range-input-picker_size_s {\n  --dl-range-input-picker-border-radius: var(--g-border-radius-s);\n  --dl-range-input-picker-font-size: var(--g-text-body-short-font-size);\n  --dl-range-input-picker-line-height: var(--g-text-body-short-line-height);\n}\n.dl-range-input-picker_size_s .dl-range-input-picker__range-info-items-list {\n  top: 31px;\n}\n.dl-range-input-picker_size_s .rc-slider-handle {\n  top: 0;\n  width: 9px;\n  height: 9px;\n}\n.dl-range-input-picker_size_s .rc-slider-track {\n  top: 4px;\n  height: 2px;\n}\n.dl-range-input-picker_size_s .rc-slider-step {\n  height: 2px;\n}\n.dl-range-input-picker_size_m {\n  --dl-range-input-picker-border-radius: var(--g-border-radius-m);\n  --dl-range-input-picker-font-size: var(--g-text-body-short-font-size);\n  --dl-range-input-picker-line-height: var(--g-text-body-short-line-height);\n}\n.dl-range-input-picker_size_m .dl-range-input-picker__range-info-items-list {\n  top: 35px;\n}\n.dl-range-input-picker_size_m .rc-slider-handle {\n  top: -1px;\n  width: 11px;\n  height: 11px;\n}\n.dl-range-input-picker_size_m .rc-slider-track {\n  top: 3px;\n  height: 3px;\n}\n.dl-range-input-picker_size_m .rc-slider-step {\n  height: 3px;\n}\n.dl-range-input-picker_size_l {\n  --dl-range-input-picker-border-radius: var(--g-border-radius-l);\n  --dl-range-input-picker-font-size: var(--g-text-body-short-font-size);\n  --dl-range-input-picker-line-height: var(--g-text-body-short-line-height);\n}\n.dl-range-input-picker_size_l .dl-range-input-picker__range-info-items-list {\n  top: 43px;\n}\n.dl-range-input-picker_size_xl {\n  --dl-range-input-picker-border-radius: var(--g-border-radius-xl);\n  --dl-range-input-picker-font-size: var(--g-text-body-2-font-size);\n  --dl-range-input-picker-line-height: var(--g-text-body-2-line-height);\n}\n.dl-range-input-picker_size_xl .dl-range-input-picker__range-info-items-list {\n  top: 51px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
